import { render, staticRenderFns } from "./ModalInquiryReopen.vue?vue&type=template&id=58863754&"
import script from "./ModalInquiryReopen.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryReopen.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryReopen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports